import { Controller } from "@hotwired/stimulus"
import DragSelect from "dragselect"
import { get, post } from "@lib/requests"

// Connects to data-controller="presence-calendar"
export default class extends Controller {
  
  connect() {
    this.boundInitializeCellSelection = this.intializeCellSelection.bind(this)
    this.boundInitializeCellSelection()
  }
  
  disconnect() {
    this.stopCellSelection()
  }
  
  intializeCellSelection() {
    // Clean up any existing instance
    this.stopCellSelection()
    
    // Use the bound method
    document.addEventListener("turbo:frame-render", this.boundInitializeCellSelection)
    
    this.cellSelection = new DragSelect({
      selectables: document.querySelectorAll(".selectable-presence-cell"),
      area: document.querySelector(".user-columns"),
      draggability: false,
      selectorClass: "opacity-0",
      selectedClass: "!bg-blue-100/80",
      hoverClass: "!bg-blue-100/80"
    });
    
    this.cellSelection.subscribe("DS:start", async (e) => {
      document.body.classList.add("drag-selecting")
    })
    
    this.cellSelection.subscribe("DS:end", async ({ event, items }) => {
      if (!event.target.classList.contains("selectable-presence-cell")) return
      
      document.body.classList.remove("drag-selecting")
      const slots = items.map(item => JSON.parse(item.dataset.params))
      
      // If there is a single slot, we will just toggle the presence
      if (slots.length === 1) return this.createSinglePresence(slots[0], event.target)
      
      this.clearSelection()
      
      await get("/presences/selection", {
        query: { slots: JSON.stringify(slots) },
        responseKind: "turbo-stream"
      })
      
    });
  }

  stopCellSelection() {
    document.removeEventListener("turbo:frame-render", this.boundInitializeCellSelection)
    if (this.cellSelection) {
      try {
        this.cellSelection.clearSelection()
        this.cellSelection.stop()
      } catch (e) {
        // Silently catch the error
      } finally {
        this.cellSelection = null
      }
    }
  }

  clearSelection() {
    this.cellSelection.clearSelection()
    document.querySelectorAll(".ds-selected, .ds-hover").forEach(item => {
      item.classList.remove("ds-selected", "ds-hover")
    })
  }

  async createSinglePresence(slot, element) {
    this.clearSelection()
    // In the interim can we optimistically update the presence?
    element.classList.remove("bg-white", "bg-gray-50", "hover:bg-blue-50")
    element.classList.add(`bg-${slot.color}`, 'opacity-80')
    element.innerHTML = `<span class="text-xxs text-white/60 uppercase">Jour</span>`
    element.style.pointerEvents = "none"
    const response = await post("/presences", { body: slot, responseKind: "turbo-stream" })
  }
  
}
